import i18next from "i18next";
import { initReactI18next } from "react-i18next";
// "Inline" English and Arabic translations.
// We can localize to any language and any number of languages.
const resources = {
    en: {
        translation: {
            app_name: "bazuba locations",
            base_location_url_path: "/en/locations",
            back_to_locations: "Back to locations",
            call_phone_number: "Call phone number",
            open_homepage: "Open homepage",
            open_route_planner: "Open route planner",
            send_an_email: "Send an email",
            Monday: "Monday",
            Tuesday: "Tuesday",
            Wednesday: "Wednesday",
            Thursday: "Thursday",
            Friday: "Friday",
            Saturday: "Saturday",
            Sunday: "Sunday",
            // Countries
            Austria: "Austria",
            Germany: "Germany",
            Italy: "Italy",
            Switzerland: "Switzerland",
            Deutschland: "Germany",
            "Österreich": "Austria",
            // States - Germany
            "Baden-Württemberg": "Baden-Württemberg",
            "Bayern": "Bavaria",
            "Berlin": "Berlin",
            "Brandenburg": "Brandenburg",
            "Bremen": "Bremen",
            "Hamburg": "Hamburg",
            "Hessen": "Hessen",
            "Mecklenburg-Vorpommern": "Mecklenburg-Vorpommern",
            "Niedersachsen": "Niedersachsen",
            "Nordrhein-Westfalen": "North Rhine-Westphalia",
            "Rheinland-Pfalz": "Rheinland-Pfalz",
            "Saarland": "Saarland",
            "Sachsen": "Sachsen",
            "Sachsen-Anhalt": "Sachsen-Anhalt",
            "Schleswig-Holstein": "Schleswig-Holstein",
            "Thüringen": "Thüringen",
            // States - Austria
            "Burgenland": "Burgenland",
            "Kärnten": "Kärnten",
            "Niederösterreich": "Niederösterreich",
            "Oberösterreich": "Oberösterreich",
            "Salzburg": "Salzburg",
            "Steiermark": "Steiermark",
            "Tirol": "Tirol",
            "Vorarlberg": "Vorarlberg",
            "Wien": "Vienna",
        },
    },
    de: {
        translation: {
            app_name: "bazuba Standorte",
            base_location_url_path: "/standorte/",
            back_to_locations: "Zurück zu den Standorten",
            call_phone_number: "Telefonnummer anrufen",
            open_homepage: "Website öffnen",
            open_route_planner: "Routenplaner öffnen",
            send_an_email: "e-Mail schreiben",
            Monday: "Montag",
            Tuesday: "Dienstag",
            Wednesday: "Mittwoch",
            Thursday: "Donnerstag",
            Friday: "Freitag",
            Saturday: "Samstag",
            Sunday: "Sonntag",
            // Countries
            Austria: "Österreich",
            Germany: "Deutschland",
            Italy: "Italien",
            Switzerland: "Schweiz",
            Deutschland: "Deutschland",
            "Österreich": "Österreich",
            // States - Germany
            "Baden-Württemberg": "Baden-Württemberg",
            "Bayern": "Bayern",
            "Berlin": "Berlin",
            "Brandenburg": "Brandenburg",
            "Bremen": "Bremen",
            "Hamburg": "Hamburg",
            "Hessen": "Hessen",
            "Mecklenburg-Vorpommern": "Mecklenburg-Vorpommern",
            "Niedersachsen": "Niedersachsen",
            "Nordrhein-Westfalen": "Nordrhein-Westfalen",
            "Rheinland-Pfalz": "Rheinland-Pfalz",
            "Saarland": "Saarland",
            "Sachsen": "Sachsen",
            "Sachsen-Anhalt": "Sachsen-Anhalt",
            "Schleswig-Holstein": "Schleswig-Holstein",
            "Thüringen": "Thüringen",
            // States - Austria
            "Burgenland": "Burgenland",
            "Kärnten": "Kärnten",
            "Niederösterreich": "Niederösterreich",
            "Oberösterreich": "Oberösterreich",
            "Salzburg": "Salzburg",
            "Steiermark": "Steiermark",
            "Tirol": "Tirol",
            "Vorarlberg": "Vorarlberg",
            "Wien": "Wien",
        },
    },
};
// @TODO Asynchronous (lazy) loading of translation files -> https://phrase.com/blog/posts/localizing-react-apps-with-i18next/
i18next
    .use(initReactI18next)
    .init({
        resources,
        lng: "de",
        interpolation: {
            escapeValue: false,
        },
        debug: process.env.NODE_ENV === "development",
    });
export default i18next;